import React from "react";
import { Home, Search, ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { 
  NotFoundContainer, 
  NotFoundCard, 
  NotFoundIcon, 
  NotFoundTitle, 
  NotFoundSubtitle, 
  NotFoundDescription, 
  ActionButtons, 
  PrimaryButton, 
  SecondaryButton,
  ErrorCode
} from "./wrappers.tsx";
import { colors } from '../../assets/colors/index.tsx';

export const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleSearch = () => {
    navigate('/');
  };

  return (
    <NotFoundContainer>
      <NotFoundCard>
        <ErrorCode>404</ErrorCode>
        
        <NotFoundIcon>
          <div style={{ 
            fontSize: '6rem', 
            color: colors.primary,
            marginBottom: '1rem'
          }}>
            🏠
          </div>
        </NotFoundIcon>
        
        <NotFoundTitle>Page Not Found</NotFoundTitle>
        
        <NotFoundSubtitle>
          Oops! The page you're looking for seems to have wandered off
        </NotFoundSubtitle>
        
        <NotFoundDescription>
          Don't worry, it happens to the best of us. The page might have been moved, 
          deleted, or you might have typed the wrong URL. Let's get you back on track!
        </NotFoundDescription>
        
        <ActionButtons>
          <PrimaryButton 
            onClick={handleGoHome}
            variant="contained"
            startIcon={<Home />}
          >
            Go Home
          </PrimaryButton>
          
          <SecondaryButton 
            onClick={handleSearch}
            variant="outlined"
            startIcon={<Search />}
          >
            Search Coliving
          </SecondaryButton>
          
          <SecondaryButton 
            onClick={handleGoBack}
            variant="text"
            startIcon={<ArrowBack />}
          >
            Go Back
          </SecondaryButton>
        </ActionButtons>
        
        <div style={{ 
          marginTop: '2rem', 
          textAlign: 'center', 
          color: colors.tertiary,
          fontSize: '0.9rem'
        }}>
          <p>Need help? Contact our support team</p>
          <button 
            onClick={() => navigate('/questions-and-answers')}
            style={{
              background: 'none',
              border: 'none',
              color: colors.primary,
              cursor: 'pointer',
              textDecoration: 'underline',
              fontSize: '0.9rem'
            }}
          >
            Visit our FAQ section
          </button>
        </div>
      </NotFoundCard>
    </NotFoundContainer>
  );
};